// // src/pages/DeviceAnalytics.js
// import React, { useEffect, useState, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import imagesLoaded from 'imagesloaded';
// import './OneStepMedi.css';

// const API_URL = 'https://api.securxperts.com:8000';
// const ENDPOINT = '/forms/contact';

// /* -------------------- CONTACT FORM ----------------------- */
// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     country_code: '',
//     phoneno: '',
//     location: '',
//     purpose: '',
//     message: '',
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name.trim()) return 'Name is required';
//     if (!form.email.trim()) return 'Email is required';
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.country_code.trim()) return 'Country code is required';
//     if (!form.phoneno.trim()) return 'Phone number is required';
//     if (!form.location.trim()) return 'Location is required';
//     if (!form.purpose.trim()) return 'Purpose is required';
//     if (!form.message.trim()) return 'Message is required';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const payload = { ...form };

//       const resp = await fetch(`${API_URL}${ENDPOINT}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch {
//           // ignore parse errors
//         }
//         setStatus({
//           type: 'success',
//           msg: data?.message || 'Thank you! Your request has been submitted.',
//         });
//         setForm({
//           name: '',
//           email: '',
//           country_code: '',
//           phoneno: '',
//           location: '',
//           purpose: '',
//           message: '',
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (error) {
//       console.error('Device Analytics contact submit error:', error);
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-3xl mx-auto bg-white/5 p-6 md:p-10 rounded-2xl shadow-lg"
//       aria-label="Device Analytics Enquiry Form"
//     >
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
//         Request a Trial or Live Demo
//       </h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="country_code"
//           value={form.country_code}
//           onChange={handleChange}
//           placeholder="Country Code (e.g. +44)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="phoneno"
//           value={form.phoneno}
//           onChange={handleChange}
//           placeholder="Phone Number"
//           type="tel"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="Company Location (City, Country)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="purpose"
//           value={form.purpose}
//           onChange={handleChange}
//           placeholder="Purpose (POC / Pilot / Rollout / Compliance)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <textarea
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           placeholder="Tell us about your workforce analytics or compliance use case"
//           rows={4}
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2 resize-none"
//         />
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full font-semibold w-full mt-6 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Request a Trial'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-4 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}

//       <p className="text-xs mt-4 text-white/60 text-center">
//         Your details will remain confidential and used only for enquiry purposes.
//       </p>
//     </form>
//   );
// };

// /* -------------------- MAIN PAGE ----------------------- */
// const DeviceAnalytics = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [showScroll, setShowScroll] = useState(false);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   // 🔁 Ref for hero video
//   const heroVideoRef = useRef(null);

//   // Image load -> hide loading screen
//   useEffect(() => {
//     imagesLoaded(
//       document.querySelectorAll('.content__item-img'),
//       { background: true },
//       () => {
//         document.body.classList.remove('loading');
//         setIsLoading(false);
//       }
//     );
//   }, []);

//   // Parallax scroll for cards
//   useEffect(() => {
//     const items = document.querySelectorAll('.content__item');

//     const handleScroll = () => {
//       items.forEach((item) => {
//         const img = item.querySelector('.content__item-img');
//         const wrapper = img?.parentNode;
//         if (!img || !wrapper) return;

//         const rect = item.getBoundingClientRect();
//         const progress = Math.min(
//           Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0),
//           1
//         );

//         const translateY = progress * 100 - 50;
//         const rotate = progress * -45;

//         img.style.transform = `translateY(${translateY}px)`;
//         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll();
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Circular scroll progress button visibility & progress
//   useEffect(() => {
//     const circumference = 307.919;
//     const handleProgress = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const docHeight = document.documentElement.scrollHeight - window.innerHeight;
//       const progress = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;
//       setScrollProgress(circumference * progress);
//       setShowScroll(scrollTop > 600);
//     };

//     window.addEventListener('scroll', handleProgress);
//     handleProgress();
//     return () => window.removeEventListener('scroll', handleProgress);
//   }, []);

//   // 🔁 Restart hero video when user scrolls back to top
//   useEffect(() => {
//     let wasNotAtTop = false;

//     const handleVideoReset = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const isAtTop = scrollTop < 50;

//       // Only reset when transitioning from not-top → top
//       if (isAtTop && wasNotAtTop && heroVideoRef.current) {
//         heroVideoRef.current.currentTime = 0;
//         heroVideoRef.current.play().catch(() => {});
//       }

//       wasNotAtTop = !isAtTop;
//     };

//     window.addEventListener('scroll', handleVideoReset);
//     handleVideoReset(); // initial check

//     return () => window.removeEventListener('scroll', handleVideoReset);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });

//     // also restart video when using the scroll-to-top button
//     if (heroVideoRef.current) {
//       heroVideoRef.current.currentTime = 0;
//       heroVideoRef.current.play().catch(() => {});
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Advanced Device Usage Analytics for Modern Workplaces</title>
//         <meta
//           name="description"
//           content="Monitor productivity, app usage, system events and user behaviour in real-time with a cross-platform analytics engine for IT, HR, compliance and business leaders."
//         />
//       </Helmet>

//       {/* Loading Screen */}
//       <div
//         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
//           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//       >
//         <h1 className="text-4xl md:text-6xl font-bold text-white animate-pulse text-center px-4">
//           Device Usage Analytics Platform
//         </h1>
//       </div>

//       {/* Navbar */}
//       <Navbar />

//       {/* Hero Video Section */}
//       <section className="relative h-screen">
//         <video
//           ref={heroVideoRef}
//           className="absolute inset-0 w-full h-full object-cover"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src="/video/log sphere.mp4" type="video/mp4" />
//         </video>
//         <div className="absolute inset-0 bg-black/60" />
//       </section>

//       {/* Main Content with Parallax */}
//       <main className="bg-black text-white">
//         <div className="content content--padded">
//           {/* Key Modules Section */}
//           <section className="py-12 max-w-5xl mx-auto text-left px-6">
//             <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
//               Explore Key Modules &amp; Capabilities
//             </h2>

//             {/* Real-Time Usage Analytics Dashboard */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Real-Time Usage Analytics Dashboard
//               </h3>
//               <p className="text-base md:text-lg">
//                 Track login/logout sessions, working hours, breaks, active windows and idle time with
//                 minute-level accuracy.
//               </p>
//             </div>

//             {/* Application & Browser Monitoring */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Application &amp; Browser Monitoring
//               </h3>
//               <p className="text-base md:text-lg">
//                 Monitors every opened application and browser tab with timestamps, duration, session behaviour
//                 and productivity classification.
//               </p>
//             </div>

//             {/* Centralised Activity Logging */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Centralised Activity Logging
//               </h3>
//               <p className="text-base md:text-lg">
//                 Automatically records system events including sleep/resume, restart, shutdown and session
//                 history.
//               </p>
//             </div>

//             {/* Productivity Heatmaps & Reports */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Productivity Heatmaps &amp; Reports
//               </h3>
//               <p className="text-base md:text-lg">
//                 Generate daily, weekly or monthly breakdowns of active time vs idle periods. Export reports in
//                 Excel, PDF or CSV for internal analysis and reviews.
//               </p>
//             </div>

//             {/* Compliance & Security Oversight */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Compliance &amp; Security Oversight
//               </h3>
//               <p className="text-base md:text-lg">
//                 Detect unapproved software, track browser history, monitor screenshots and maintain trace logs.
//                 Supports secure data handling with GDPR-focused architecture.
//               </p>
//             </div>

//             {/* Role-Based Access Modules */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Role-Based Access Modules
//               </h3>
//               <p className="text-base md:text-lg">
//                 Admins access organisation-wide analytics while users view only personal usage summaries for
//                 self-assessment.
//               </p>
//             </div>

//             {/* Cross-Platform Tracking Engine */}
//             <div className="mb-2">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Cross-Platform Tracking Engine
//               </h3>
//               <p className="text-base md:text-lg">
//                 Runs seamlessly on Windows, macOS and Linux using native system hooks for reliable, low-impact
//                 tracking.
//               </p>
//             </div>
//           </section>

//           {/* Parallax Cards – Analytics visuals */}
//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/analytics-dashboard.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Unified Analytics Dashboard</h2>
//             <p className="content__item-description">
//               Visualise working hours, utilisation and focus time across teams in one consolidated view.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/app-monitoring.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Deep App &amp; Web Insights</h2>
//             <p className="content__item-description">
//               Understand which tools drive productivity and which apps drain focus with detailed app/web usage
//               analytics.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/productivity-heatmap.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Productivity Heatmaps</h2>
//             <p className="content__item-description">
//               Spot peak performance hours, bottlenecks and under-utilised teams using intuitive heatmaps and
//               trends.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/compliance-security.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Compliance-Ready Monitoring</h2>
//             <p className="content__item-description">
//               Maintain transparent, auditable logs with policies built around privacy, security and
//               GDPR-aligned practices.
//             </p>
//           </div>

//           {/* CTA */}
//           <section className="text-center py-32">
//             <h2 className="text-4xl md:text-7xl font-bold mb-6">
//               The Future of Workforce Analytics — Efficient, Compliant &amp; Insight-Driven
//             </h2>
//             <p className="text-base md:text-xl text-white/80 max-w-3xl mx-auto mb-8">
//               Turn everyday device activity into strategic insights that improve productivity, compliance and
//               employee experience.
//             </p>
//             <div className="space-x-8">
//               <a
//                 href="#contact"
//                 className="inline-block bg-blue-600 text-white px-10 py-5 rounded-full text-2xl font-bold hover:bg-blue-700 transition transform hover:scale-110"
//               >
//                 Request a Trial
//               </a>
//             </div>
//           </section>

//           {/* Contact section */}
//           <section id="contact" className="py-16 bg-gradient-to-b from-black to-gray-900">
//             <div className="max-w-6xl mx-auto px-6">
//               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
//                 Talk to Our Workforce Analytics Team
//               </h3>
//               <p className="text-center text-white/70 mb-8">
//                 Share your requirements around productivity analytics, compliance monitoring or hybrid work and
//                 we’ll design the right rollout plan for you.
//               </p>

//               <ContactForm />
//             </div>
//           </section>
//         </div>
//       </main>

//       {/* Footer */}
//       <Footer />

//       {/* Scroll to Top Button (arrow) */}
//       <button
//         onClick={scrollToTop}
//         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
//       >
//         <svg className="w-16 h-16 text-white drop-shadow-2xl" viewBox="0 0 512 512">
//           <path fill="currentColor" d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z" />
//         </svg>
//       </button>

//       {/* Circular Scroll Progress Button */}
//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
//         >
//           <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="-1 -1 102 102">
//             <path
//               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray="307.919"
//               strokeDashoffset={307.919 - scrollProgress}
//               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-6 h-6 text-white relative z-10"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
//           </svg>
//         </div>
//       )}
//     </>
//   );
// };

// export default DeviceAnalytics;







import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const API_URL = "https://api.securxperts.com:8000";
const ENDPOINT = "/forms/contact";

/* ----------------------------------------------------
   CONTACT FORM COMPONENT (LOGIC UNCHANGED)
----------------------------------------------------- */
const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    country_code: "",
    phoneno: "",
    location: "",
    purpose: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const validate = () => {
    if (!form.name.trim()) return "Name is required";
    if (!form.email.trim()) return "Email is required";
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(form.email)) return "Enter a valid email";
    if (!form.country_code.trim()) return "Country code is required";
    if (!form.phoneno.trim()) return "Phone number is required";
    if (!form.location.trim()) return "Location is required";
    if (!form.purpose.trim()) return "Purpose is required";
    if (!form.message.trim()) return "Message is required";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    const err = validate();
    if (err) {
      setStatus({ type: "error", msg: err });
      return;
    }

    setSubmitting(true);

    try {
      const resp = await fetch(`${API_URL}${ENDPOINT}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form }),
      });

      if (resp.ok) {
        let data = null;
        try {
          data = await resp.json();
        } catch {}

        setStatus({
          type: "success",
          msg: data?.message || "Thank you! Your request has been submitted.",
        });

        setForm({
          name: "",
          email: "",
          country_code: "",
          phoneno: "",
          location: "",
          purpose: "",
          message: "",
        });
      } else {
        let errText = "Submission failed";
        try {
          const json = await resp.json();
          errText = json?.message || json?.error || errText;
        } catch {}
        setStatus({ type: "error", msg: errText });
      }
    } catch {
      setStatus({ type: "error", msg: "Network error. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-3xl mx-auto bg-white p-6 md:p-10 rounded-2xl shadow-lg border"
    >
      <h3 className="text-3xl font-bold text-center mb-6">
         Request a Trial or Live Demo
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name"
          className="w-full p-3 rounded-lg border outline-none" />

        <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email"
          className="w-full p-3 rounded-lg border outline-none" />

        <input name="country_code" value={form.country_code} onChange={handleChange}
          placeholder="Country Code (+44)" className="w-full p-3 rounded-lg border outline-none" />

        <input name="phoneno" value={form.phoneno} onChange={handleChange}
          placeholder="Phone Number" className="w-full p-3 rounded-lg border outline-none" />

        <input name="location" value={form.location} onChange={handleChange}
          placeholder="Organisation Location"
          className="w-full p-3 rounded-lg border outline-none md:col-span-2" />

        <input name="purpose" value={form.purpose} onChange={handleChange}
          placeholder="Purpose (Campus, Corporate, Training)"
          className="w-full p-3 rounded-lg border outline-none md:col-span-2" />

        <textarea name="message" value={form.message} onChange={handleChange}
          placeholder="Tell us about your hiring process" rows="4"
          className="w-full p-3 rounded-lg border outline-none md:col-span-2" />
      </div>

      <button
        type="submit"
        disabled={submitting}
        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full w-full mt-6"
      >
        {submitting ? "Submitting..." : "Request a Trial"}
      </button>

      {status && (
        <p
          className={`text-center mt-4 ${
            status.type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {status.msg}
        </p>
      )}
    </form>
  );
};

export default function kpi() {
  const features = [
  {
    title: " Live Productivity Dashboards",
    description: " Monitor workforce activity with real-time visualisations of login/logout patterns, application usage, and idle periods, enabling managers to quickly assess productivity and take timely action to optimise team performance.",
  },
  {
    title: " Advanced Activity Heatmaps",
    description: " Interactive heatmaps provide insights into team efficiency, highlighting high-performing employees and identifying areas that require additional support, helping managers make informed decisions for operational improvement.",
  },
  {
    title: "Automated Event Tracking",
    description: " System events such as restarts, shutdowns, sleep cycles and session histories are automatically recorded, providing complete transparency and enabling IT teams to track operational consistency across all devices.",
  },
  {
    title: " GDPR-Compliant Data Management",
    description: " All user activity, event logs and application tracking are securely stored and fully compliant with GDPR and other data protection regulations, ensuring privacy while maintaining operational visibility and audit readiness.",
  },
  {
    title: "Role-Based Access Controls",
    description: " Grant customised access levels to administrators, managers and employees, allowing each user to view relevant insights securely, ensuring data confidentiality while enabling actionable, role-specific decision-making.",
  },
  {
    title: "Exportable Analytics & Reports",
    description: " Generate and download detailed reports in Excel, PDF or CSV formats, covering productivity, application usage and workforce activity, supporting audits, performance reviews and strategic workforce planning initiatives.",
  },
];

  return (
    <div className="w-full font-sans bg-white text-[#063852]">
<Navbar/>
      {/* =========================================================
          HERO SECTION
      ========================================================== */}
      <section className="w-full bg-gradient-to-br from-blue-50 to-white py-2 px-6 md:px-16">
         {/* Logo Placeholder
  <div className="absolute top-10 left-6 md:top-5 md:left-16 z-20 ">
    <img
      src="/img/logosphare.png"   // <-- Replace with your logo file
      alt="aroganarayan logo"
      className="w-32 md:w-40 object-contain"
    />
    </div> */}
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">

          {/* LEFT TEXT */}
          <div>
             <img
            src="/img/logosphare.png"
            alt="Logo"
            className="w-32 mb-6"
          />
            <h1 className="text-4xl font-bold leading-tight mb-4">
             Intelligent Device & Workforce Monitoring

            </h1>
            <p className="text-gray-600 mb-8">
             Monitor productivity, app usage, system events and user activity in real time, providing actionable insights for HR, IT and business leaders. The platform helps organisations identify workflow bottlenecks, improve employee performance and maintain compliance with detailed activity logs. With intelligent alerts and advanced analytics, teams can make faster, data-driven decisions. Designed with enterprise-grade security, it ensures complete visibility and control across all devices.


            </p>

            {/* <div className="flex gap-4">
              <button className="px-6 py-3 bg-[#0066cc] text-white rounded-lg">
                View Tutorials
              </button>
              <button className="px-6 py-3 bg-white border border-gray-300 rounded-lg">
                Book a Demo
              </button>
            </div> */}
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center">
            <img
              src="/img/logosphare (2).png"
              alt="Monitoring Dashboard"
              className="w-96"
            />
          </div>
        </div>
      </section>

      {/* =========================================================
          VIDEO SECTION
      ========================================================== */}
        {/* FULL-WIDTH VIDEO SECTION – LOOP + CLICK PAUSE/PLAY + RESTART ON REFRESH */}
<section className="w-full py-20 px-6 md:px-0 bg-gray-50">
  <div className="max-w-7xl mx-auto">
 
    <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
      <video
        className="w-full block"
        src="/video/logsphere.mp4"
        muted                    // Required for autoplay
        playsInline
        autoPlay                 // Starts immediately
        loop                     // Plays continuously forever
        preload="auto"
        controls={false}         // No control bar
        // Restart from beginning every time page loads/refreshes
        key="lauratek-video"    
        // Click = Pause / Play
        onClick={(e) => {
          const video = e.currentTarget;
          video.paused ? video.play() : video.pause();
        }}
      >
        Your browser does not support HTML5 video.
      </video>
 
      {/* ONLY Fullscreen Button – appears on hover */}
      <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <button
          onClick={(e) => {
            e.stopPropagation();
            const video = e.currentTarget.closest('div').querySelector('video');
            if (video.requestFullscreen) video.requestFullscreen();
            else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
            else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
            else if (video.msRequestFullscreen) video.msRequestFullscreen();
          }}
          className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
          title="Fullscreen"
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5" />
          </svg>
        </button>
      </div>
 
      {/* Optional: Subtle pulsing play icon in center */}
      {/* <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="animate-pulse">
          <div className="w-20 h-20 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z"/>
            </svg>
          </div>
        </div>
      </div> */}
    </div>
 
  </div>
</section>

      {/* =========================================================
          ALL-IN-ONE MONITORING SOLUTION
      ========================================================== */}
      <section className="w-full py-16 px-6 md:px-16 bg-[#f8fbff]">
        <h2 className="text-3xl font-bold text-center mb-12">
        Optimised Employee Engagement Experience

        </h2>

        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">

          {/* CARD 1 */}
          <div className="p-6 bg-white rounded-xl shadow text-center">
            <img src="/img/robo.png" className="mx-auto mb-4 w-14" />
            <h3 className="font-bold text-xl mb-2">Instant Activity Insights
</h3>
            <p className="text-gray-600 text-sm">
               Track active sessions, idle periods and app usage for timely, informed decisions.

            </p>
          </div>

          {/* CENTER CARD BIG */}
          <div className="p-6 bg-white rounded-xl shadow text-center">
            <img src="/img/crossdevice.png" className="mx-auto mb-4 w-14" />
            <h3 className="font-bold text-xl mb-2">Cross-Device Monitoring
</h3>
            <p className="text-sm">
              Monitor Windows, macOS and Linux devices seamlessly with accurate reporting.

            </p>
          </div>

          {/* CARD 3 */}
          <div className="p-6 bg-white rounded-xl shadow text-center">
            <img src="/img/rolebased.png" className="mx-auto mb-4 w-14" />
            <h3 className="font-bold text-xl mb-2">Role-Based Dashboards
</h3>
            <p className="text-gray-600 text-sm">
              Managers, leads and staff access only relevant analytics for efficient oversight.

            </p>
          </div>

          {/* CARD 4 */}
          <div className="p-6 bg-white rounded-xl shadow text-center">
            <img src="/img/audit.png" className="mx-auto mb-4 w-14" />
            <h3 className="font-bold text-xl mb-2">Audit & Compliance Tracking
</h3>
            <p className="text-gray-600 text-sm">
              Aggregate Logs system events including restarts, sleep/resume cycles and session histories in a secure, central repository for efficient oversight and historical reference.

            </p>
          </div>

          {/* CARD 5 */}
          <div className="p-6 bg-white rounded-xl shadow text-center">
            <img src="/img/improvedhr.png" className="mx-auto mb-4 w-14" />
            <h3 className="font-bold text-xl mb-2">Advanced Application Insights

</h3>
            <p className="text-gray-600 text-sm">
             Capture metrics for software and browser sessions, covering duration, usage frequency, and productivity classification for accurate performance monitoring.

            </p>
          </div>

          {/* CARD 6 */}
          <div className="p-6 bg-white rounded-xl shadow text-center">
            <img src="/img/datadriven.png" className="mx-auto mb-4 w-14" />
            <h3 className="font-bold text-xl mb-2">Data-Driven Performance Reports
</h3>
            <p className="text-gray-600 text-sm">
             Generate daily, weekly, or monthly productivity heatmaps and export reports in Excel, PDF or CSV to support management analysis and review.

            </p>
          </div>
        </div>
      </section>

      {/* =========================================================
          KEEP MONITORING EVERYWHERE YOU GO
      ========================================================== */}
      <section className="w-full py-20 px-6 md:px-16 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
          
          <div>
            <img
              src="/img/workforcemonitoringfromanywhere.png"
              alt="Monitoring Everywhere"
              className="w-full"
            />
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-4">
              Keep Monitoring <br /> Everywhere You Go
            </h2>
            <p className="text-gray-600 mb-6">
              Access your monitoring dashboard from your phone, tablet, or laptop.
              Stay updated anytime, anywhere.
            </p>
            {/* <button className="px-6 py-3 bg-[#0066cc] text-white rounded-lg">
              Sign Up Now
            </button> */}
          </div>
        </div>
      </section>

      {/* =========================================================
          ADVANCED FEATURES
      ========================================================== */}
    <section className="w-full py-20 px-6 md:px-16 bg-[#0099e6] text-white">
  <h2 className="text-3xl font-bold text-center mb-10">
    Key Features of Log Sphere
  </h2>

  <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
    {features.map((item, i) => (
      <div
        key={i}
        className="p-6 bg-white text-[#063852] rounded-xl shadow text-center"
      >
        {/* 6 Different Icon Placeholders */}
        {i === 0 && <img src="/img/liveproductivity.png" className="mx-auto mb-4 w-12" />}
        {i === 1 && <img src="/img/heatmaps.png" className="mx-auto mb-4 w-12" />}
        {i === 2 && <img src="/img/automatedevent.png" className="mx-auto mb-4 w-12" />}
        {i === 3 && <img src="/img/gdpr (3).png" className="mx-auto mb-4 w-12" />}
        {i === 4 && <img src="/img/rolebased (1).png" className="mx-auto mb-4 w-12" />}
        {i === 5 && <img src="/img/exportable.png" className="mx-auto mb-4 w-12" />}

        <h3 className="font-semibold text-lg mb-2">{item.title}</h3>
        <p className="text-gray-600 text-sm">{item.description}</p>
      </div>
    ))}
  </div>
</section>

      <ContactForm />
      <Footer/>  
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-8 right-8 z-50 w-14 h-14 bg-purple-700 text-white rounded-full shadow-lg hover:bg-purple-800 transition flex items-center justify-center"
      >
        ↑
      </button>
    </div>
  );
}
